import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CashAccountTransactionsReport  {
    _originalTypeClassName = "zERP.BO.CashAccountTransactionsReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CashAccountTransactionsReport.translate = translateService;
}
this.Transactions = [];
this.DateFrom = null;
this.DateTo = null;
this.CashAccountTransactionsReportKey = null;
this._key = this.CashAccountTransactionsReportKey = 0; 
}

static translate: TranslateService;
_key: any;
DateFrom:any;
DateTo:any;
CashAccount:any;
Transactions:any;
private _CashAccountTransactionsReportKey:any;
get CashAccountTransactionsReportKey(): any {
    return this._CashAccountTransactionsReportKey;
  }
set CashAccountTransactionsReportKey(value: any) {
    this._CashAccountTransactionsReportKey = value;
    this._key = value;
  }
static setCashAccount = ($this, value) => {
var oldValue = $this.CashAccount;
$this.CashAccount = value;
if (value != null) {
}
}
static setTransactions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Transactions == null) $this.Transactions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Transactions.length > 0) {
                    Domain.CashAccountTransactionsReport.removeTransactions($this, $this.Transactions[0]);
                }

                Domain.CashAccountTransactionsReport.addManyTransactions($this, copyItems);
            }
static addManyTransactions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CashAccountTransactionsReport.addTransactions($this, items[i]);
                }
            }
static addTransactions = ($this, item) => {
                if ($this.Transactions == null) $this.Transactions = [];
                if (item == null || $this.Transactions.indexOf(item) > -1) return;
                $this.Transactions.push(item);
}
static addRangeTransactions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CashAccountTransactionsReport.addTransactions($this, item));
            }
static removeTransactions = ($this, item) => {
                if ($this == null || $this.Transactions == null || $this.Transactions.indexOf(item) === -1) return;
                var _index = $this.Transactions.indexOf(item);
                $this.Transactions.splice(_index, 1);
}
static clearTransactions = ($this) => { $this.Transactions = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CashAccountTransactionsReportKey == null || $this.CashAccountTransactionsReportKey == 0;
            }


}